import { DocumentReference } from "@angular/fire/firestore";

export class Venue {
  public city: DocumentReference;
  public description: string;
  public id?: string;
  public image: string;
  public is_active: boolean;
  public redirect: boolean;
  public redirect_url: string;
  public name: string;
  public rank: number;
  public passes?: number;
  public thumbnail: string;

  constructor(data, id) {
    this.city = data["city"];
    this.description = data["description"];
    this.id = id;
    this.image = data["image"];
    this.is_active = data["is_active"];
    this.redirect = data["redirect"];
    this.redirect_url = data["redirect_url"];
    this.name = data["name"];
    this.rank = data["rank"];
    this.passes = 0;
    this.thumbnail = data["thumbnail"];
  }

  get path(): string {
    return this.city.path + "/Venues/" + this.id;
  }
  get reference(): DocumentReference {
    return this.city.collection("Venues").doc(this.id);
  }
  toJSON() {
    return {
      city: this.city,
      description: this.description,
      image: this.image,
      is_active: this.is_active,
      redirect: this.redirect,
      redirect_url: this.redirect_url,
      name: this.name,
      rank: this.rank,
      thumbnail: this.thumbnail
    };
  }
}
